/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
import React from 'react';
import {
    arrayOf, number, shape, string,
} from 'prop-types';

import Button from '@material-ui/core/Button';
import Media from 'react-media';
import OrderListItem from './OrderListItem';
import SearchInput from '../../common/Search';
import configENV from '../../config';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import DesktopOrderList from '../DesktopOrdersList/DesktopOrderList';

const { MAX_ORDER_LIST } = configENV;

class OrderList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            allOrders: [],
            maxItem: MAX_ORDER_LIST, // Limited to 30 orders for the first view
            loadMoreClicked: false,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const orders = this.regroupOrders(this.props.orders); // eslint-disable-line react/destructuring-assignment
        this.setState({ orders, allOrders: orders });
    };

    // randRange = max => Math.floor(Math.random() * Math.floor(max));

    // orderStatus = () => {
    //     // I->In transit
    //     // D/U->Delivered
    //     // C->Cancelled
    //     // W and all other status->Order Received
    //     const status = ['C', 'W', 'I', 'D'];
    //     const step = this.randRange(4);
    //     if (step >= 0 && step < 4) {
    //         return status[step];
    //     }
    //     return 'W';
    // };

    scrollTop = () => {
        if (typeof window !== 'undefined') {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }
    };

    regroupOrders = (orders) => {
        const newOrders = [];
        orders.map((order) => {
            const index = newOrders.findIndex((item) => item.orderNumber === order.orderNumber);
            if (index > -1) {
                const { items } = order;
                items.map((item) => {
                    item.modifyOrder = order.modifyOrder;
                    if (
                        typeof item.status === 'undefined'
                        && typeof item.paymentStatus !== 'undefined'
                    ) {
                        item.status = item.paymentStatus;
                    }
                    // For development only
                    // item.status = this.orderStatus();
                    newOrders[index].items.push(item);
                });
            } else {
                const { items } = order;
                items.map((item) => {
                    item.modifyOrder = order.modifyOrder;
                    if (
                        typeof item.status === 'undefined'
                        && typeof item.paymentStatus !== 'undefined'
                    ) {
                        item.status = item.paymentStatus;
                    }
                    // For development only
                    // item.status = this.orderStatus();
                });
                newOrders.push(order);
            }
        });
        return newOrders;
    };

    handleSearchOrdersChange = (data) => {
        const { search } = data;
        const { orders: regroupOrders } = this.props;
        const orders = regroupOrders.filter((order) => {
            const { items } = order;
            const itemJoin = items.map((item) => [
                item.productSku,
                item.recpFirstName,
                item.recpLastName,
                item.trackingNumber,
            ].join(' '));
            return [order.orderNumber, itemJoin]
                .join(' ')
                .match(new RegExp(search, 'ig'));
        });
        this.setState({ orders });
    };

    handleLoadMoreOrders = () => {
        let { maxItem } = this.state;
        maxItem += maxItem;
        this.setState({ maxItem, loadMoreClicked: true });
    };

    render() {
        const { allOrders, maxItem, loadMoreClicked } = this.state;
        const { breakpoint } = this.props;
        let { orders } = this.state;
        orders = orders.slice(0, maxItem);
        const breakpointExpr =  `(max-width: ${(breakpoint || CUSTOM_BREAKPOINTS.tabLandscape)}px)`;
        return (
            <>
                <SearchInput
                    label="Search Order"
                    className="display-none"
                    onChange={this.handleSearchOrdersChange}
                />

                <Media query={breakpointExpr}>
                    {(matches) => (
                        matches ? (
                            orders.map((order, i) => (
                                <OrderListItem
                                    key={order.intOrderNumber}
                                    order={order}
                                    className={i === orders.length - 1 ? 'last' : ''}
                                />
                            ))
                        ) : (
                            orders.map((order) => (
                                <DesktopOrderList key={order.intOrderNumber} order={order} />
                            ))
                        )
                    )}
                </Media>
                {allOrders.length > orders.length ? (
                    <div className="align-center margin-top-2x margin-bottom-2x">
                        <Button
                            onClick={() => this.handleLoadMoreOrders()}
                            variant="contained"
                            className="do-not-remove-btn secondary float-none"
                        >
                            Load More Orders
                        </Button>
                    </div>
                ) : (
                    ''
                )}
                {loadMoreClicked ? (
                    <div className="align-center margin-top-2x margin-bottom-2x">
                        <Button
                            onClick={() => this.scrollTop()}
                            variant="contained"
                            className="do-not-remove-btn float-none link"
                        >
                            Back To Top ^
                        </Button>
                    </div>
                ) : (
                    ''
                )}
            </>
        );
    }
}
OrderList.defaultProps = {
    breakpoint: CUSTOM_BREAKPOINTS.tabLandscape,
};
OrderList.propTypes = {
    orders: arrayOf(
        shape({
            orderNumber: string,
            intOrderNumber: string,
            orderPlaceddate: string,
            customerFirstName: string,
            customerLastName: string,
            modifyOrder: string,
            parentOrderNumber: string,
            uuid: string,
            items: arrayOf(
                shape({
                    brandId: string,
                    productSku: string,
                    productName: string,
                    recpFirstName: string,
                    recpLastName: string,
                    shipDate: string,
                    paymentStatus: string,
                    estimatedDeliveryDate: string,
                    trackingNumber: string,
                    itemType: string,
                    sfItemType: string,
                    addonType: string,
                    parentLineNumber: string,
                    childLineNumber: string,
                    flexDate: string,
                    flexMessage: string,
                    flexGuaranteedFlag: string,
                    prdImgCtg: string,
                    prdImgTmn: string,
                    arrivalStartDate: string,
                    arrivalEndDate: string,
                    carrier: string,
                    seoUrl: string,
                    subscriptionType: string,
                    interval: string,
                    duration: string,
                }),
            ),
        }),
    ).isRequired,
    breakpoint: number,
};

export default OrderList;
